export enum ApiKeys {
  DashboardExperience = 'activate/dashboard/v1',
  OrderDeliveryDetails = 'activate/customerengagement/dashboard/order_delivery_details/v1',
}
